var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoorHangar = function SvgDoorHangar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.611 5.2C15.962 3.84 14.502 2 11.726 2 9.283 2 7.46 3.428 6.422 5.567 7.397 6.771 8.87 6.88 8.87 6.88s.951-1.877 2.565-1.877c2.493 0 2.995 3.868.065 4.31-1.532.23-3.008.34-4.516 1.212-1.47 3.301-1.142 8.777 0 11.373 2.742 1.355 6.98 1.582 9.997 0 1.534-3.802 1.285-13.23-.37-16.698"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14.75c1.666 1 4.334 1 6 0M9 18.5c1.666 1 4.334 1 6 0"
  }))));
};
export default SvgDoorHangar;